import { InputRadio } from "@itandi/itandi-bb-ui/InputRadio";
import { useFormContext, useWatch } from "react-hook-form";
import type { DealSurveyOption, SurveyAnswers } from "~/models/Survey";

type Props = {
	surveyIndex: number;
	surveyOption: DealSurveyOption;
};
export function SurveyRadio({ surveyIndex, surveyOption }: Props) {
	const { register, formState, control } = useFormContext<SurveyAnswers>();
	const surveyOptionId = useWatch({
		control,
		name: `answers.${surveyIndex}.surveyOptionId`
	});
	const surveyOptionIdError =
		formState.errors.answers?.[surveyIndex]?.surveyOptionId || null;
	return (
		<InputRadio
			checked={String(surveyOptionId) === String(surveyOption.id)}
			isInvalid={surveyOptionIdError !== null}
			label={surveyOption.text}
			value={String(surveyOption.id)}
			{...register(`answers.${surveyIndex}.surveyOptionId`)}
		/>
	);
}
